module.exports = __webpack_public_path__ + "static/media/recipt-gray.7ee07f2e.svg";